"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _shadows = require("../shadows");
const styleOverrides = {
  badge: ({
    ownerState
  }) => ({
    boxShadow: 'none',
    border: `1px solid ${_constants.colors.commonColors.white}`,
    fontSize: '1rem',
    letterSpacing: 0,
    lineHeight: 1.5,
    height: 22,
    minWidth: 22,
    borderRadius: 11,
    padding: '0 3px',
    top: '20%',
    ...(ownerState.color === 'default' && {
      backgroundColor: _constants.colors.commonColors.white,
      color: _constants.colors.text.primary,
      boxShadow: _shadows.SHADOW_LEVEL3
    })
  }),
  dot: {
    width: 10,
    height: 10,
    minWidth: 'unset',
    borderRadius: '50%',
    padding: 0
  }
};
const defaultProps = {
  color: 'default',
  overlap: 'circular'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiBadge.js.map